module.exports = __webpack_public_path__ + "play_store_badge.db9b21a.png";